export interface ForgotState {
  contents: any;
  error: Error | null;
}
export const initialForgotState: ForgotState = {
  contents: new Object(),
  error: null,
};
